import React, { useEffect, useState } from 'react';
import { checkDelivery } from '../../services/orderService';
import '../../css/phase1.css';

const STORAGE_KEY = 'mithralaya.pincode';

const formatDeliveryDate = (value) =>
  value
    ? new Date(value).toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'short' })
    : '';

// "Check delivery" on the product page. Remembers the last pincode so a
// returning shopper sees their delivery date immediately.
const DeliveryCheck = ({ price = 0 }) => {
  const [pincode, setPincode] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(false);

  const runCheck = async (code) => {
    if (!/^[1-9][0-9]{5}$/.test(code)) {
      setError('Enter a valid 6-digit pincode');
      setResult(null);
      return;
    }
    setChecking(true);
    setError('');
    try {
      const data = await checkDelivery(code);
      setResult(data);
      try {
        localStorage.setItem(STORAGE_KEY, code);
      } catch (e) {
        /* storage unavailable */
      }
    } catch (err) {
      setResult(null);
      setError(err.response?.data?.message || 'Could not check this pincode right now. Please try again.');
    } finally {
      setChecking(false);
    }
  };

  useEffect(() => {
    let saved = '';
    try {
      saved = localStorage.getItem(STORAGE_KEY) || '';
    } catch (e) {
      saved = '';
    }
    if (saved) {
      setPincode(saved);
      runCheck(saved);
    }
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    runCheck(pincode.trim());
  };

  return (
    <form className="p1-pincode" onSubmit={onSubmit}>
      <label className="p1-pincode-label" htmlFor="pdp-pincode">Check delivery</label>
      <div className="p1-pincode-row">
        <input
          id="pdp-pincode"
          inputMode="numeric"
          autoComplete="postal-code"
          placeholder="Enter pincode"
          value={pincode}
          maxLength={6}
          onChange={(e) => {
            setPincode(e.target.value.replace(/\D/g, ''));
            setError('');
          }}
        />
        <button type="submit" disabled={checking || pincode.length !== 6}>
          {checking ? 'Checking…' : 'Check'}
        </button>
      </div>

      <div className="p1-pincode-result" aria-live="polite">
        {error && <span className="no">{error}</span>}
        {result && !result.serviceable && (
          <span className="no">{result.message || 'We do not deliver to this pincode yet.'}</span>
        )}
        {result && result.serviceable && (
          <>
            <span className="ok">
              Delivery by {formatDeliveryDate(result.deliveryBy)}
              {result.estimated ? ' (estimated)' : ''}
            </span>
            <ul className="p1-pincode-perks">
              <li>
                {price >= result.freeShippingAbove
                  ? 'Free delivery'
                  : `Free delivery on orders above ₹${result.freeShippingAbove}`}
              </li>
              {result.shippingCharge != null && (
                <li>Courier estimate ₹{result.shippingCharge} (approximate)</li>
              )}
              <li>{result.codAvailable ? 'Cash on Delivery available' : 'Cash on Delivery not available here'}</li>
              {result.returnWindowDays > 0 && <li>{result.returnWindowDays}-day returns</li>}
            </ul>
          </>
        )}
      </div>
    </form>
  );
};

export default DeliveryCheck;
